export {};
//# sourceMappingURL=Linking.types.js.map